export const teamData = {
  name: "SevenMotorSport TM Factory Support",
  tagline: "Racing Excellence Since Day One",
  description: "SevenMotorSport TM Factory Support rappresenta l'eccellenza nel motocross europeo. Con il supporto tecnico di TM Racing, il nostro team compete ai massimi livelli nelle categorie EMX125 ed EMX250, portando in pista talento, passione e determinazione.",
  mission: "La nostra missione è sviluppare giovani talenti del motocross, fornendo loro il supporto tecnico e professionale necessario per eccellere nelle competizioni europee e raggiungere i più alti livelli del motorsport.",
  video: "/media/upha2w4d_TMSEVEN_ALMONTE_SPAIN_MXGP_TENRO_16-9.mp4",
  poster: "/media/upha2w4d_TMSEVEN_ALMONTE_SPAIN_MXGP_TENRO_16-9-poster.jpg",
  videoMobile: "/media/hero-mobile.mp4",
  posterMobile: "/media/hero-mobile-poster.jpg",
  logo: "/media/caxotx42_unnamed.jpg"
};

export const riders = [
  {
    id: 1,
    name: "Francesco Quintili",
    number: "320",
    category: "EMX125",
    nationality: "Italiana",
    flag: "🇮🇹",
    bio: "Giovane promessa italiana del motocross, Francesco rappresenta il futuro della categoria EMX125. Con una tecnica raffinata e una determinazione incrollabile, si fa strada tra i migliori piloti europei della sua categoria. La sua crescita costante e la capacità di adattarsi a diverse condizioni di gara dimostrano il suo talento naturale e la dedizione al motocross. Francesco incarna i valori del Team Seven Motorsport: passione, impegno e voglia di eccellere ai massimi livelli.",
    image: "/media/tylc6ix8_MXGP_ANDALUCIA-30.jpg",
    stats: null,
    achievements: null
  },
  {
    id: 2,
    name: "Douwe Van Mechgelen",
    number: "18",
    category: "EMX250",
    nationality: "Belga",
    flag: "🇧🇪",
    bio: "Pilota belga di grande talento, Douwe porta esperienza e velocità nella categoria EMX250. La sua guida aggressiva e il suo spirito competitivo lo rendono uno degli avversari più temibili in pista.",
    image: "/media/nfihx7u9_MXGP_ANDALUCIA-53.jpg",
    stats: {
      races: "7",
      podiums: "0",
      bestPosition: "10th"
    },
    achievements: [
      "Dutch Master Champ 2025",
      "2nd at Le Touquet Juniors 2022"
    ]
  }
];

export const gallery = [
  {
    id: 1,
    url: "/media/s0ujahf9_MXGP_ANDALUCIA-06.jpg",
    title: "Team Photo",
    category: "team"
  },
  {
    id: 2,
    url: "/media/qufl497o_MXGP_ANDALUCIA-26.jpg",
    title: "Francesco Quintili #320",
    category: "riders"
  },
  {
    id: 3,
    url: "/media/f2uojiur_MXGP_ANDALUCIA-49.jpg",
    title: "Douwe Van Mechgelen #18",
    category: "riders"
  },
  {
    id: 4,
    url: "/media/tylc6ix8_MXGP_ANDALUCIA-30.jpg",
    title: "Douwe Van Mechgelen Action",
    category: "action"
  },
  {
    id: 5,
    url: "/media/hslduxdz_MXGP_ANDALUCIA-53.jpg",
    title: "Douwe Van Mechgelen Portrait",
    category: "riders"
  },
  {
    id: 6,
    url: "/media/zxns50rs_MXGP_ANDALUCIA-12.jpg",
    title: "Action Shot",
    category: "action"
  },
  {
    id: 7,
    url: "/media/73tjthdv_MXGP_ANDALUCIA-14.jpg",
    title: "Racing Moment",
    category: "action"
  },
  {
    id: 8,
    url: "/media/23obyyri_MXGP_ANDALUCIA-22.jpg",
    title: "Track Action",
    category: "action"
  },
  {
    id: 9,
    url: "/media/1adsedu7_MXGP_ANDALUCIA-23.jpg",
    title: "Racing Scene",
    category: "action"
  },
  {
    id: 10,
    url: "/media/rvsxp98b_MXGP_ANDALUCIA-57.jpg",
    title: "Competition",
    category: "action"
  },
  {
    id: 11,
    url: "/media/ytv7otah_MXGP_ANDALUCIA-55.jpg",
    title: "Racing Action",
    category: "action"
  },
  {
    id: 12,
    url: "/media/atgxethm_MXGP_ANDALUCIA-56.jpg",
    title: "Track Performance",
    category: "action"
  }
];

export const achievements = [
  {
    id: 1,
    year: "2024",
    title: "GP Andalucia Victory",
    rider: "Douwe Van Mechgelen",
    category: "EMX250"
  },
  {
    id: 2,
    year: "2024",
    title: "Top 10 Championship",
    rider: "Francesco Quintili",
    category: "EMX125"
  },
  {
    id: 3,
    year: "2024",
    title: "Multiple Podiums",
    rider: "Team",
    category: "EMX Series"
  }
];

export const sponsors = [
  {
    id: 1,
    name: "TM Moto",
    category: "Factory Support",
    tier: "main",
    logo: "/media/pcrt91c9_LOGO-TM-DEFINITIVO_4.png"
  },
  {
    id: 2,
    name: "AC Management",
    category: "Management",
    tier: "main",
    logo: "/media/3aezuwk3_AC-logo-png-.png"
  },
  {
    id: 3,
    name: "I Quintili",
    category: "Pizza e Food",
    tier: "premium",
    logo: "/media/lm1estg2_quintili_logo.png"
  },
  {
    id: 4,
    name: "Solarpro",
    category: "Energia",
    tier: "premium",
    logo: "/media/62e63x23_solarpro.png"
  },
  {
    id: 5,
    name: "Saci Group",
    category: "Informatica",
    tier: "premium",
    logo: "/media/1jylvj2z_saci_group.png"
  },
  {
    id: 6,
    name: "Techno Care",
    category: "Tecnologia",
    tier: "premium",
    logo: "/media/4vx1milj_techno_care.png"
  },
  {
    id: 7,
    name: "Bio Impianti",
    category: "Elettricità",
    tier: "premium",
    logo: "/media/jvspvhi9_bio_impianti.png"
  },
  {
    id: 8,
    name: "Castel Rock",
    category: "Food",
    tier: "premium",
    logo: "/media/pxfxcdx2_castle_rock.png"
  },
  {
    id: 9,
    name: "La Torrente",
    category: "Food",
    tier: "premium",
    logo: "/media/p2c6dyd1_la-torrente.png"
  },
  {
    id: 10,
    name: "Mozzarè",
    category: "Food",
    tier: "premium",
    logo: "/media/v1qw2ter_mozzare-.png"
  },
  {
    id: 11,
    name: "Pneus",
    category: "Pneumatici",
    tier: "premium",
    logo: "/media/eder8xaw_pneus.png"
  },
  {
    id: 12,
    name: "Wonderfull Signal",
    category: "Segnaletica Stradale",
    tier: "premium",
    logo: "/media/sruuipex_wonderfull.png"
  },
  {
    id: 13,
    name: "Pirelli",
    category: "Pneumatici",
    tier: "technical",
    logo: "/media/n3s0cmx3_pirelli.png"
  },
  {
    id: 14,
    name: "Raven",
    category: "Abbigliamento",
    tier: "technical",
    logo: "/media/iee25qal_raven.png"
  },
  {
    id: 15,
    name: "Motocross Marketing",
    category: "Marketing",
    tier: "technical",
    logo: "/media/b03xum2x_motocross_marketing.png"
  },
  {
    id: 16,
    name: "Bell",
    category: "Caschi",
    tier: "technical",
    logo: "/media/wivi3p9a_BELL.png"
  },
  {
    id: 17,
    name: "Alpinestars",
    category: "Abbigliamento",
    tier: "technical",
    logo: "/media/pi8hfmev_Alpinestars-Logo-1993-present.png"
  },
  {
    id: 13,
    name: "InnTeck",
    category: "Marketing",
    tier: "technical",
    logo: "/media/vm8xltcy_innTeck.png"
  },
  {
    id: 14,
    name: "Mika Metals",
    category: "Manubri",
    tier: "technical",
    logo: "/media/kha0tsd9_mika.png"
  },
  {
    id: 15,
    name: "Il Ruotino",
    category: "E-Commerce",
    tier: "technical",
    logo: "/media/jjom62lh_il_ruotino.png"
  },
  {
    id: 16,
    name: "24mx",
    category: "E-Commerce",
    tier: "technical",
    logo: "/media/kb6wu68o_24_mx.png"
  },
  {
    id: 17,
    name: "Go Big Shop",
    category: "E-Commerce",
    tier: "technical",
    logo: "/media/1upmtu1w_logo-gobig.webp"
  },
  {
    id: 18,
    name: "HGS",
    category: "Scarichi",
    tier: "technical",
    logo: "/media/46muhgt0_hgs.png"
  },
  {
    id: 19,
    name: "Galfer",
    category: "Freni",
    tier: "technical",
    logo: "/media/etwutt2l_galfer.png"
  },
  {
    id: 20,
    name: "LRX",
    category: "Grafiche",
    tier: "technical",
    logo: "/media/mjvvdge0_x_grpx.png"
  },
  {
    id: 21,
    name: "Marchald",
    category: "Filtri dell'Aria",
    tier: "technical",
    logo: "/media/oeb99pkn_marchald.png"
  },
  {
    id: 22,
    name: "Renox",
    category: "Lubrificanti Sintetici",
    tier: "technical",
    logo: "/media/my3gzw0z_renox.png"
  },
  {
    id: 23,
    name: "Crossx",
    category: "Selle",
    tier: "technical",
    logo: "/media/4e8q2ac1_cross-x.png"
  },
  {
    id: 24,
    name: "Hurly",
    category: "Accessori",
    tier: "technical",
    logo: "/media/60jn5dfz_hurly.png"
  },
  {
    id: 25,
    name: "SKF",
    category: "Cuscinetti",
    tier: "technical",
    logo: "/media/s0o2krcs_skf.png"
  }
];

export const socialMedia = {
  instagram: "#",
  facebook: "#",
  youtube: "#",
  email: "info@sevenmotorsport.com"
};
